import {
  GET_ALL_MULTI_BET_BONUSES,
  GET_ALL_MULTI_BET_BONUSES_RESPONSE_SUCCESS,
  CREATE_MULTI_BET_BONUS,
  UPDATE_MULTI_BET_BONUS,
  DELETE_MULTI_BET_BONUS,
} from "./actionTypes"

export const getAllMultiBetBonuses = () => {
  return {
    type: GET_ALL_MULTI_BET_BONUSES,
  }
}
export const getAllMultiBetBonusesResponseSuccess = payload => ({
  type: GET_ALL_MULTI_BET_BONUSES_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createMultiBetBonus = (payload, history) => {
  return {
    type: CREATE_MULTI_BET_BONUS,
    payload: payload,
    history,
  }
}

// ------------------------------------- EDIT --------------------------------------------------------

export const updateMultiBetBonus = (payload, history, redirectTo) => {
  return {
    type: UPDATE_MULTI_BET_BONUS,
    payload: payload,
    history,
    redirectTo,
  }
}

// ------------------------------------- DELETE --------------------------------------------------------

export const deleteMultiBetBonus = payload => ({
  type: DELETE_MULTI_BET_BONUS,
  payload: payload,
})
